import { FormControl as BaseFormControl } from "@chakra-ui/react";

export default BaseFormControl;
